import { Nullable } from 'utils/types';

export enum FIELD {
  FIRM_ID = 'firmId',
}

export type Form = {
  [FIELD.FIRM_ID]: Nullable<number>;
};
